'use client';

import type { ItemsListConfig, ReceiptSettings } from '@/lib/templates/schema';
import { SectionDivider } from './SectionDivider';

interface ItemsListSectionProps {
  config: ItemsListConfig;
  settings: ReceiptSettings;
}

export function ItemsListSection({ config, settings }: ItemsListSectionProps) {
  const qtyOnLeft = config.quantityPosition !== 'right';
  const isNarrow = settings.spacing === 'narrow';

  return (
    <div className={`receipt-section ${isNarrow ? 'py-0.5' : 'py-2'}`}>
      {/* Top Divider */}
      {config.showTopDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} className={isNarrow ? 'mb-0.5' : 'mb-2'} />
      )}

      {/* Header Row */}
      {config.showHeader && (
        <div
          className={`flex justify-between gap-1 ${isNarrow ? 'mb-0.5' : 'mb-1'} ${config.showHeaderDivider ? 'border-b pb-1' : ''}`}
          style={{
            fontSize: settings.fontSize,
            fontFamily: settings.font,
            borderColor: settings.textColor,
          }}
        >
          {config.showQuantity && qtyOnLeft && (
            <span className="w-6 shrink-0">{config.headerLabels?.quantity}</span>
          )}
          <span className="flex-1 whitespace-pre">{config.headerLabels?.item}</span>
          {config.showQuantity && !qtyOnLeft && (
            <span className="w-6 shrink-0 text-right">{config.headerLabels?.quantity}</span>
          )}
          <span className="shrink-0 text-right whitespace-pre">{config.headerLabels?.amount}</span>
        </div>
      )}

      {/* Items */}
      <div className={isNarrow ? '' : 'space-y-1'} style={{ lineHeight: isNarrow ? 1.15 : 1.4 }}>
        {config.items.map((item) => (
          <div
            key={item.id}
            className="flex justify-between gap-1"
            style={{
              fontSize: settings.fontSize,
              fontFamily: settings.font,
            }}
          >
            {config.showQuantity && qtyOnLeft && (
              <span className="w-6 shrink-0 whitespace-pre">{item.quantity || '1'}</span>
            )}
            <span className="flex-1 whitespace-pre">{item.name}</span>
            {config.showQuantity && !qtyOnLeft && (
              <span className="w-6 shrink-0 text-right whitespace-pre">{item.quantity || '1'}</span>
            )}
            <span className="shrink-0 text-right whitespace-pre">{item.price}</span>
          </div>
        ))}
      </div>

      {/* Bottom Divider */}
      {config.showDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} />
      )}
    </div>
  );
}

